import { Component, Input, OnInit, signal, ViewChild } from '@angular/core';
import { EventModel } from 'src/app/services/user-events/models/user-events.model';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PlatformsCalendarDialogComponent } from 'src/app/components/dialogs/platforms-calendar-dialog/platforms-calendar-dialog.component';
import { PlatformModel } from 'src/app/components/dialogs/platforms-calendar-dialog/platform.model';
import { getEventIconLigature } from './user-event-icons';
import { ApiService } from '../../../../../services/api.service';
import { UserService } from '../../../../../services/user.service';

@Component({
  selector: 'user-event-item',
  templateUrl: './user-event-item.component.html',
  styleUrls: ['./user-event-item.component.scss'],
})
export class UserEventItemComponent implements OnInit {
  icon: string;

  @Input()
  userEvent: EventModel;

  @Input()
  isHeader = false;

  readonly platforms = signal<PlatformModel[]>([]);
  
  @ViewChild(PlatformsCalendarDialogComponent) platformsCalendarDialog!: PlatformsCalendarDialogComponent;

  constructor(
    private dialog: MatDialog,
    public userService: UserService,
    public apiService: ApiService
  ) { }

  ngOnInit() {
    this.retrieveIcon();
    this.platforms.set([{
      name: 'Google Calendar',
      link: this.userEvent.googleCalendar,
      icon: 'google',
    },
    {
      name: 'Microsoft Outlook',
      link: this.userEvent.microsoftCalendar,
      icon: 'windows',
    },
    {
      name: 'Apple Calendar',
      link: this.userEvent.appleCalendar,
      icon: 'apple',
    }]);
  }

  retrieveIcon() {
    this.icon = getEventIconLigature(this.userEvent.type);
  }

  openEvent(userEvent: EventModel) {
    if (userEvent.learningExperienceId != null) {
      this.openLearningExperienceWithLoginToken(userEvent.learningExperienceId);
      return;
    }

    window.open(userEvent.link, '_blank', 'noopener');
  }

  openLearningExperienceWithLoginToken(learningExperienceId: string) {
    const params = {
      patronId: this.userService.getUserId(),
    };

    this.apiService.getLinkToBookclub(params).subscribe((bookClubLoginLink) => {
      const link = bookClubLoginLink + '&clubId=' + learningExperienceId;
      window.open(link, '_blank', 'noopener');
    });
  }

  openCalendarDialog() {
    this.platformsCalendarDialog.dialog.openDialog();
  }
}
